import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const FormFeedbackCardContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  alignSelf: "stretch",
  borderRadius: "8px",
  border: `1px solid ${colors.error200}`,
  backgroundColor: colors.error50,
}));

export const FormFeedbackCardIconContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: "8px",
  padding: "12px",
}));

interface FormFeedbackCardTextProps {
  color?: string;
}
export const FormFeedbackCardText = styled("span")(
  ({ color = colors.error700 }: FormFeedbackCardTextProps) => ({
    display: "flex",
    padding: "12px 12px 12px 0px",
    alignItems: "flex-start",
    gap: "4px",
    alignSelf: "stretch",
    flexDirection: "column",
    color,

    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
  })
);
